/**
 * Um shard só (Renato, 04/11): a ShardScreen entra direto nele e a tela de personagens esconde o "Trocar de shard".
 * A ShardScreen sempre roda antes da de personagens (o login e o boot vão para 'shard'), então é ela que marca.
 */
let unico = false;

export function marcarShardUnico(valor: boolean): void {
  unico = valor;
}

export function ehShardUnico(): boolean {
  return unico;
}
